import api from '../api'
import store from '@/store'
import {VersionedAPIPath} from "@/api/api";

const resourcesRoutePrefix = VersionedAPIPath+'/resources';

export default {
    //Get Active Clients
    async getActiveClients(){
        let url = resourcesRoutePrefix+'/get-active-clients';
        return api.get(url, { timeout: 10000} );
    },

    //Get Active Projects for client ()
    async getActiveProjectsForClient($clientId){
      let url = resourcesRoutePrefix+'/get-active-projects-for-client'+'/'+$clientId;
      return api.get(url, { timeout: 10000} );
    },
    //Get checklists... not passing a checklist id will return the default checklist for the project!
    async getChecklist($checklistId = null){
        let baseRoute = resourcesRoutePrefix+'/get-checklist';
        let url = ($checklistId)? baseRoute+'/'+$checklistId : baseRoute;
        return api.get(url, {
            params:{
                lang : store.getters.getUserLanguage
            }
        });
    },
    async getCustomLmraList($listKey = null){
        let baseRoute = resourcesRoutePrefix+'/get-custom-lmra-list';
        let url = ($listKey)? baseRoute + '/' + $listKey : baseRoute;
        return api.get(url, {
            params:{
                lang : store.getters.getUserLanguage
            },
            timeout :  20000  //20 second timeout on this one!
        });
    },
    async getDynamicQuestionsList($listId = null){
        let baseRoute = resourcesRoutePrefix+'/get-dynamic-question-list';
        let url = ($listId)? baseRoute + '/' + $listId : baseRoute;
        return api.get(url, {
            params:{
                lang : store.getters.getUserLanguage
            },
            timeout :  10000  //10 second timeout on this one!
        });
    },
    async getDefaultWhatsAppGroupCode(){
        let url = resourcesRoutePrefix+'/get-default-whatsapp-group-code';
        return api.get(url, {
            params:{
                lang : store.getters.getUserLanguage
            },
            timeout :  10000  //10 second timeout on this one!
        });
    },
    async getEmergencyNumbersOverview(){
        let url = resourcesRoutePrefix+'/get-emergency-numbers-overview';
        return api.get(url, {
            params:{
                lang : store.getters.getUserLanguage
            },
            timeout :  10000  //10 second timeout on this one!
        })
    }
}